import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e6e09d08&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=e6e09d08&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=e6e09d08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e09d08",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PzImage: require('/drone/src/components/PzImage/index.vue').default})
